import * as angular from 'angular';
import NavbarController from "../../controllers/navbar.controller";
import StandardComponent from "components/standards/components/StandardComponent";

"use strict";

class BlocworxNavbarSelected extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/blocworx/components/navbar/components/selected';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
        data: '<',
        selected: '<',
        bootstrap: '<'
    }

    // This will set what will be the controller of this component
    public controller : any = NavbarController;

    // This will set an alias
    public controllerAs: string = 'navbar';
}

angular.module('BlocworxModule').component('blocworxNavbarSelected', <StandardComponent> new BlocworxNavbarSelected);